<script>
  export let data;
  export let isMobile;

  import { fly } from "svelte/transition";
  import Year from "./Year.svelte";

  const years = [...new Set(data.map((d) => d.year))].reverse();

  const referenceYears = isMobile
    ? [1971, 2021]
    : [1971, 1980, 1990, 2000, 2010, 2021];
  let minimapExpanded = false;

  import { currentYear } from "../../stores/global.js";

  $: translateXAmount = isMobile ? "-87%" : "-91%";
</script>

{#if $currentYear}
  <div
    transition:fly={{ x: -200, y: 0, duration: 500 }}
    class="minimap"
    class:isMobile
    style="transform: {minimapExpanded == true
      ? 'translateX(0)'
      : `translateX(${translateXAmount})`};"
  >
    <div class="main-minimap-content">
      {#each years as year, index}
        <Year
          {year}
          {isMobile}
          current={$currentYear ? ($currentYear == year ? true : false) : false}
          data={data.filter((d) => d.year == year)}
          even={index % 2 == 0}
          {referenceYears}
          {minimapExpanded}
        />
      {/each}
    </div>
    <div
      class="toggle-arrow"
      on:click={() => {
        minimapExpanded = !minimapExpanded;
      }}
    >
      Map
    </div>
  </div>
{/if}

<style>
  .minimap {
    position: absolute;
    top: 6%;
    display: flex;
    width: auto;
    background: #444d7d;
    background: linear-gradient(to left, #444d7d 70%, black 300%);
    z-index: 20;
    border-radius: 0 5px 5px 0;
    box-shadow: 1px 1px 4px #1e1e1e80;
    transition: transform 400ms ease;
  }

  .minimap.isMobile {
    top: calc(4% + 25px + 5%);
  }

  .main-minimap-content {
    padding: 5px;
    display: flex;
  }

  .toggle-arrow {
    text-align: center;
    line-height: 1;
    display: flex;
    place-items: center;
    padding: 6px;
    cursor: pointer;
    border-left: 1px solid rgba(0, 0, 0, 0.2);
    font-family: var(--font-subhead);
    text-transform: uppercase;
    font-size: 0.8rem;
  }

  .isMobile .toggle-arrow {
    font-size: 0.6rem;
  }
</style>
